import { CustomUser, UserRole } from '../../../types';
import { searchAgents } from '../agent/agentProvider';
import { jobApplicationAssigneeUsers, jobApplicationHrUsers } from '../../../job-application/constants';
import { AgentStatus } from '../../../domain/types';

/**
 * everything here is pretty much mocked, ideally the provider functions inside here
 * will call dedicated proxy apis for auth users when we will implement a service for that
 */

export interface SearchUsersFilters {
  q?: string,
  roles?: UserRole[],
}

async function fetchAgentsAsJobApplicationUser(q?: string): Promise<CustomUser[]> {
  if (!q) return [];

  const result = await searchAgents({ q, active: AgentStatus.ACTIVE });

  return result.content.map((agent) => ({
    name: `${agent.name.name} ${agent.name.surname}`,
    given_name: agent.name.name,
    family_name: agent.name.surname,
    email: agent.email.work || agent.email.personal,
    'https://backoffice.dove.it/roles': agent.isManager ? [UserRole.AREA_MANAGER] : [UserRole.AGENT],
  }));
}

async function fetchUsersForRole(role: UserRole, q?: string): Promise<CustomUser[]> {
  if ([UserRole.AGENT, UserRole.AREA_MANAGER].includes(role)) {
    if (!q) return [];
    return fetchAgentsAsJobApplicationUser(q);
  }

  let staticUsers = [...jobApplicationHrUsers, ...jobApplicationAssigneeUsers].filter(
    (u) => u['https://backoffice.dove.it/roles'].includes(role),
  );

  if (q) {
    const lower = q.toLowerCase();
    staticUsers = staticUsers.filter(
      (u) => u.name.toLowerCase().includes(lower) || u.email?.toLowerCase().includes(lower),
    );
  }

  return staticUsers;
}

export async function searchUsers(filters?: SearchUsersFilters): Promise<CustomUser[]> {
  const requestedRoles = filters?.roles ?? Object.values(UserRole);

  const uniqueRolesToFetch = [...new Set(
    requestedRoles.map((role) => (role === UserRole.AREA_MANAGER ? UserRole.AGENT : role)),
  )];

  const results = await Promise.all(
    uniqueRolesToFetch.map((role) => fetchUsersForRole(role, filters?.q)),
  );

  return results.flat().sort((a, b) => (a.name.localeCompare(b.name)));
}
